import View from "app/core/View";
import template from "app/layout/LayoutView.html";
import LayoutViewModel from "app/layout/LayoutViewModel";
import "common/widgets/DFErrorNotification/DFErrorNotification";
import "app/widgets/PopUpWindow/PopUpWindow";
import "common/bindings/reference";
export default {

    // The actual view
    _layout: null,
    _displayed: null,

    /**
     * Render another view inside the layout.
     * @param view View to render
     */
    showView: function(view) {
        const last = this._displayed;
        this._displayed = view;
        this._layout.showIn("#module", view);
        if(last) {
            last.destroy();
        }
    },

    render: function() {
        var model = new LayoutViewModel();
        this._layout = new View(template, {
            model: model,
            init: $.proxy(model.onInit, model),
            wrap: false
        });
        this._layout.render(document.body);
    }
}
